export enum AB155ExpressLimitExperimentVariants {
	V1 = 'ab155-v1',
	Control = 'ab155-control',
	Off = 'off',
}
